import React from 'react'
import qs from 'qs'
import { APP_DIR } from 'src/constants/routes'
import { Redirect, Route, Switch } from 'react-router-dom'
import Global from 'src/Components/buyers/Global/Global'
import Preview from 'src/features/preview'
import HomeSearch from 'src/features/homeSearch'

// Constants
import { PATH_HELPERS } from 'src/constants/navigation'

// Helpers
import { buildBasicSearchUrl } from 'src/helpers/ylopo'

// Components
import Root from './Root'
import AuthCallback from './AuthCallback'
import Styleguide from './Styleguide'
import App from './App'
import Chromebot from './Chromebot'
import NotFound from './NotFound'
import SignUp from './SignUp'
import MlsDisclaimers from './MlsDisclaimers'

const getBuyerRedirect = props => `/${APP_DIR}/buy${props.match.url}`
const generateListingsSearchRedirectRoute = props => {
  const {
    location: { search },
  } = props
  const { clientId } = qs.parse(search, {
    ignoreQueryPrefix: true,
  })

  return buildBasicSearchUrl(clientId)
}

const Routes = () => (
  <div>
    <Switch>
      <Route exact path='/' component={Root} />
      <Route exact path='/auth/callback' component={AuthCallback} />
      <Route path='/homebot-for-chrome' component={Chromebot} />
      <Route path='/mls-disclaimers' component={MlsDisclaimers} />
      <Route path='/sign-up' component={SignUp} />
      <Route
        path={PATH_HELPERS.listingsSearchRedirect.buildPath()}
        component={props => {
          window.location.href = generateListingsSearchRedirectRoute(props)
          return null
        }}
      />
      <Route path='/home-search/:customerProfileId' component={HomeSearch} />
      <Route
        path='/home-search'
        render={props => (
          <Redirect
            to={`/home-search/${process.env.REACT_APP_HOME_SEARCH_DEFAULT_CUSTOMER_ID}`}
          />
        )}
      />
      <Route path='/preview' component={Preview} />
      <Route path='/styleguide' component={Styleguide} />
      <Route path={`/${APP_DIR}`} component={App} />
      <Route
        exact
        path='/:buyerId([-0-9a-f]{36})?'
        render={props => <Redirect to={getBuyerRedirect(props)} />}
      />
      <Route component={NotFound} />
    </Switch>
    <Global />
  </div>
)

export default Routes
